import scrollListenWithRequestAnimationFrame from 'shared/assets/scripts/scrollListenWithRequestAnimationFrame'

export default class ArticleProgressBar {
	private progressBarWrapper: HTMLElement | null
	private progressBar: HTMLElement | null | undefined
	private article: HTMLElement | null

	constructor() {
		this.progressBarWrapper = document.querySelector('.articleProgressBar')
		this.progressBar = this.progressBarWrapper?.querySelector('.articleProgressBar-progress')
		this.article = document.querySelector('.article-content')
		this.updateProgressBar = this.updateProgressBar.bind(this)
	}

	init() {
		this.addEvent()
	}

	addEvent() {
		scrollListenWithRequestAnimationFrame(this.updateProgressBar)
	}

	/**
	 * Update the UI of the progressBar
	 */
	updateProgressBar() {
		if (this.scrollProgression > 0) {
			this.progressBarWrapper?.classList.add('isVisible')
		} else {
			this.progressBarWrapper?.classList.remove('isVisible')
		}

		if (this.progressBar && this.article) {
			this.progressBar.style.transform = `scaleX(${this.scrollProgression})`
		}
	}

	/**
	 * Get the progression of the scroll relative to the article
	 * @returns {number} - The progression of the scroll
	 */
	get scrollProgression(): number {
		if (this.article) {
			const { top: articleOffset, height: articleHeight } =
				this.article.getBoundingClientRect()
			const progress = -articleOffset / (articleHeight - window.innerHeight)

			return Math.max(0, Math.min(1, progress))
		}
		return 0
	}
}
